import * as React from 'react';
import BoxDefault from '../../../components/Box';
import { Application } from '../types';
import VideoPreview from './VideoPreview';

interface VResponseBoxProps {
    application: Application;
    selectedQuestionKey: string | undefined;
    onClick: (selectedQuestionKey: string) => void;
}

const Box = BoxDefault.extend`
    display: flex;
    justify-content: space-between;
    padding: 0;
    border-radius: 0.5em;
    overflow: hidden;
    cursor: pointer;
`;

const QuestionsBox: React.FC<VResponseBoxProps> = props => (
    <div>
        {props.application.answers.map((answer, index) => {
            return (
                <Box
                    key={answer.key}
                    onClick={() => props.onClick(answer.key)}
                    selected={props.selectedQuestionKey === answer.key}
                >
                    <h3 style={{ margin: '1em' }}>Question {index + 1}</h3>
                    <VideoPreview videoId={answer.videoId} />
                </Box>
            );
        })}
    </div>
);

export default QuestionsBox;



// WEBPACK FOOTER //
// ./src/scenes/hiring-manager/components/QuestionsBox.tsx